import { render } from "./MenuButtonList.vue?vue&type=template&id=6f00eadd&scoped=true"
import script from "./MenuButtonList.vue?vue&type=script&lang=js"
export * from "./MenuButtonList.vue?vue&type=script&lang=js"

import "./MenuButtonList.vue?vue&type=style&index=0&id=6f00eadd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f00eadd"]])

export default __exports__